"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.landingPageClasses = void 0;
var _mui = require("@ori-ui/mui");
const landingPageClasses = exports.landingPageClasses = (0, _mui.generateUtilityClasses)('LandingPage', [
    'description',
    'topBanner',
    'categoriesSection',
    'articlesSection'
]);
